import React from 'react';
import styles from './TitleSection.module.sass';

export const TitleSection = (props) => {
  return (
    <div className={styles.TitleSection}>
      <h6>{props.title}</h6>
      {props.children}
    </div>
  );
};
